export const EXPORT_EXCEL_API_ENDPOINT = '/api/Issue/ExportIssueDetails';

export const EXPORT_EXCEL_FILE_PREFIX = 'IssueExport';

export const EXCEL_FILE_EXTENSION = '.xlsx';

export const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const SUPPORTED_EXCEL_MIME_TYPES: ReadonlySet<string> = new Set<string>([
  EXCEL_MIME_TYPE,
  'application/vnd.ms-excel',
  'application/octet-stream',
  'application/zip',
]);

export const MINIMUM_EXPORT_BLOB_SIZE_BYTES = 1;

export const DOWNLOAD_URL_REVOCATION_DELAY_MS = 0;

export const EXPORT_ERROR_MESSAGES = {
  noActiveFilter: 'Select one filter before exporting.',
  multipleActiveFilters: 'Only one export filter can be active at a time.',
  missingYearFilterType: 'Select a year filter type before exporting.',
  missingSaa: 'Enter or select an SAA value before exporting.',
  missingCcnLegal: 'Enter or select a CCN / Legal value before exporting.',
  invalidDate: 'The selected export date is invalid.',
  invalidTaxAccountingIssueType: 'Select either All Issues or ASC 740-10 before exporting.',
  emptyBlob: 'The export API returned an empty file.',
  invalidBlobType: 'The export API returned an unsupported file type.',
  exportAlreadyRunning: 'An export is already in progress.',
  genericExportFailure: 'Unable to export the Excel file. Please try again.',
} as const;
